<template>
  <div class="contaniner">
    <div class="CoalModel_box_title">
      <el-page-header @back="getReturn" content="调整历史"> </el-page-header>
    </div>
    <el-divider></el-divider>

    <el-tabs v-model="editableTabsValue" @tab-click="handleClick">
      <el-tab-pane
        :key="item.name"
        v-for="(item, index) in editableTabs"
        :label="item.title"
        :name="item.name"
      >
      </el-tab-pane>
    </el-tabs>
    <component :is="tabComponent" :coalMineNo="coalMineNo"></component>
  </div>
</template>

<script>
export default {
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  components: {},
  data() {
    return {
      editableTabs: [
        {
          title: "煤种",
          name: "1",
        },
        {
          title: "煤仓",
          name: "2",
        },
        // {
        //   title: "供应计划",
        //   name: "3",
        // },
        // {
        //   title: "采购计划",
        //   name: "3",
        // },
      ],
      editableTabsValue: "1",
      tabComponent: "",
    };
  },
  mounted() {
    this.handleClick();
  },
  methods: {
    handleClick(targetName = "", action = "") {
      switch (+targetName.name) {
        case 1:
          this.tabComponent = () => import("./adjustComponents/CoalHistory");
          break;
        case 2:
          this.tabComponent = () => import("./adjustComponents/BunkerHistory");
          break;
        case 4:
          this.tabComponent = () =>
            import("./adjustComponents/praticularsHistory");
          break;
        default:
          //可选
          this.tabComponent = () => import("./adjustComponents/CoalHistory");
      }
    },
    getReturn() {
      this.$emit("Adjust", false);
    },
    detailLink() {
      this.$emit("checkDetail");
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
  font-size: 14px;
}
.el-select {
  margin-right: 30px;
}
.el-table {
  width: 80%;
}
.contaniner {
  padding-bottom: 100px;
}
</style>